module.exports = __webpack_public_path__ + "static/media/o10.dc756410.png";